/**
 * 公用Dialog组件
 * @author VenDream
 * @since 17/10/18
 */
import React, { Component } from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './dialog.less';

class Dialog extends Component {
  static propTypes = {
    // 自定义样式
    style: PropTypes.object,
    // 是否模态
    modal: PropTypes.bool,
    // 弹窗内容
    content: PropTypes.any,
    // 自定义类名
    classname: PropTypes.string,
    // 是否显示右上角关闭按钮
    closeBtn: PropTypes.bool,
    // 关闭弹窗
    onClose: PropTypes.func,
    parent: PropTypes.object,
    mountTo: PropTypes.object, // 要挂载到的父dom节点
  };

  static defaultProps = {
    style: { width: 500, height: 250 },
    modal: false,
    content: '',
    mountTo: document.body, // 默认挂载在body下
    onClose: () => {},
  };

  handleClickMask = () => {
    !this.props.modal && this.close();
  };

  close = () => {
    const { onClose, parent } = this.props;
    onClose && onClose.call(parent);
  };

  render() {
    const { style = {}, content, classname, closeBtn, mountTo } = this.props;
    const { width = 0, height = 0 } = style;
    const cls = classnames('s-dialog', 'transitionable', classname);
    const dialogStyle = Object.assign({}, style);

    // 保持居中
    if (width) {
      dialogStyle.marginLeft = -width / 2;
    }
    if (height) {
      dialogStyle.marginTop = -height / 2;
    }

    const contentJsx = (
      <div className={cls}>
        <div className="s-dialog-mask" onClick={this.handleClickMask} />
        <div className="s-dialog-content" style={dialogStyle}>
          {closeBtn && (
            <div className="s-dialog-close-btn" onClick={this.close} />
          )}
          {content}
        </div>
      </div>
    );

    return ReactDom.createPortal(contentJsx, mountTo);
  }
}

export default Dialog;
